import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

const DialogAttachment = (props) => {

    //const openDialog = props.openDialog;
    const openDialog = props.openDialog;

    const handleCloseDialog = () => {
        props.actionDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle variant="dialogTitle-nk" id="alert-dialog-title" color="error">
                Error
            </DialogTitle>
            <DialogContent>
                <Typography color="error">El archivo que trata de subir no está permitido.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} autoFocus variant='outlined' size="small">
                    Entendido
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default DialogAttachment;